import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M1.824 3.802c-.542-.571-.813-.857-.823-1.1a.66.66 0 0 1 .26-.547C1.458 2 1.865 2 2.678 2h10.642c.813 0 1.22 0 1.418.155a.66.66 0 0 1 .26.548c-.01.242-.28.528-.823 1.1l-4.091 4.309c-.108.114-.162.17-.201.235a.7.7 0 0 0-.074.184c-.018.073-.018.149-.018.302v3.613c0 .132 0 .198-.022.255a.34.34 0 0 1-.095.132c-.048.041-.113.066-.243.115l-2.438.92c-.263.098-.395.148-.5.127a.36.36 0 0 1-.227-.144c-.06-.085-.06-.218-.06-.486V8.833c0-.153 0-.23-.017-.302a.7.7 0 0 0-.074-.184 1.5 1.5 0 0 0-.2-.235z"
    }, null, -1)
  ])))
}
export default { render: render }